import React from 'react';
import { useTranslation } from 'react-i18next';
import type { PapiDeviation } from '@wix/da-papi-types';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import { DeviationTypes } from '../../../../types/deviation';
import { getDeviationType } from '../../../_helpers';
import { getTranslationKeyForAccessibleDeviationLink } from '../../helpers';
import s from './ThumbLink.scss';

interface Props {
  deviation: PapiDeviation;
  width?: number;
  height?: number;
  wrapperClassName?: string;
  children: React.ReactNode;
}

const ThumbLink: React.FC<Props> = ({ deviation, width, height, children, wrapperClassName }) => {
  const { t } = useTranslation();
  const a11yLabel = getTranslationKeyForAccessibleDeviationLink(t, deviation);
  const linkAsWrapper = getDeviationType(deviation) === DeviationTypes.IMAGE;

  if (linkAsWrapper) {
    return (
      <DeviationLink
        aria-label={a11yLabel}
        deviation={deviation}
        className={wrapperClassName}
        style={{ width, height }}
      >
        {children}
      </DeviationLink>
    );
  }

  return (
    <div style={{ width, height }} className={wrapperClassName}>
      {children}
      <DeviationLink deviation={deviation} className={s['link-overlay']} aria-label={a11yLabel}>
        <span />
      </DeviationLink>
    </div>
  );
};
ThumbLink.displayName = 'ThumbLink';

export default ThumbLink;
